export default __webpack_public_path__ + "static/media/templates.02a2d18b.svg";